var unitPrice = "{{ pricePerUnit }} per stykk";
var unitsCount = "{{ unitsCount }} enheter";
var unitCount = "{{ unitsCount }} enhet";
var unitPriceWithQuantity = "{{ pricePerUnit }} per stykk / {{ unitsCount }} enheter";
var vatInclusive = "Inkl. MVA";
var vatExclusive = "Ekskl. MVA";
var excludeShipping = "Ekskl. {{ shipping }}";
var includeShipping = "Inkl. {{ shipping }}";
var shipping = "frakt";
var vatAndShipping = {
	includeVatExcludeShipping: "Inkl. MVA, ekskl. {{ shipping }}",
	excludeVatIncludeShipping: "Ekskl. MVA, inkl. {{ shipping }}",
	includeVatIncludeShipping: "Inkl. MVA, inkl. {{ shipping }}",
	excludeVatExcludeShipping: "Ekskl. MVA, ekskl. {{ shipping }}"
};
var priceSummary = "Prisoversikt";
var priceSummaryInfoIcon = "Informasjonsikon for prisoversikt";
var priceSummaryModal = "Modalvindu for prisoversikt";
var priceSummaryCloseModal = "Lukk modalvindu for prisoversikt";
var priceSummaryTermsAndConditions = "* Det lages en unik skjerm eller pute for hver bestilling, og utstyret tilpasses for å trykke designet du har designet. ";
var priceSummaryBasePrice = "Grunnpris";
var priceSummarySetupFee = "Oppstartsgebyr*";
var priceSummarySubtotal = "Delsum";
var differentialPrice = {
	included: "Inkludert",
	forUnits: "for {{ differentialPrice }} stk.",
	forUnit: "for {{ differentialPrice }} stk."
};
var priceFrom = "Fra {{ price }}";
var volumeDiscount = "{{volumeDiscount}} % kvantumsrabatt";
var volumeDiscountPlusSale = "{{volumeDiscount}} % kvantumsrabatt + tilbud";
var rangePrice = "{{xx}}–{{yy}}";
var unitRangePrice = "{{rangePrice}} per stk.";
var originalPrice = "opprinnelig pris:";
var salePrice = "aktuell tilbudspris:";
var setupFee = "{{ setupFee }} oppstartsgebyr påløper";
var noSetupFee = "Ingen oppstartsgebyr";
var vatAndSetupFee = {
	noVatInclSetup: "Inkl. {{ setupFee }} oppstartsgebyr",
	inclVatAndSetup: "Inkl. {{ setupFee }} oppstartsgebyr og MVA",
	exclVatInclSetup: "Inkl. {{ setupFee }} oppstartsgebyr, ekskl. MVA",
	inclVatSetupInclShipping: "Inkl. {{ setupFee }} oppstartsgebyr og MVA, inkl. {{ shipping }}",
	inclVatSetupExclShipping: "Inkl. {{ setupFee }} oppstartsgebyr og MVA, ekskl. {{ shipping }}",
	exclVatSetupInclShipping: "Inkl. {{ setupFee }} oppstartsgebyr, ekskl, MVA, inkl. {{ shipping }}",
	exclVatSetupExclShipping: "Inkl. {{ setupFee }} oppstartsgebyr, ekskl. MVA og {{ shipping }}"
};
var nbno = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee
};

export { nbno as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFrom, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
//# sourceMappingURL=ep-pricing-esm-localization-texts-nb-no.json.js.map
